module.exports = __webpack_public_path__ + "assets/img/ava3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/ava3.png
// module id = 1988
// module chunks = 0